import { setSelectedObjectId } from "../../../../../app/state/storageObjectSlice/slice";
import { getFileConfig } from "../../../../../features/Files/helpers";
import { getFileContentAction } from "../../../../../features/Files/redux/actions";
import {
  clearFilesState,
  setFileConfig,
  setFilesValue,
} from "../../../../../features/Files/redux/slice";
import { SaveFileValue } from "../../../../api/instances/saveFileApi/types";
import { dispatchCancellable } from "../../../../lib/dispatchCancellable";
import { ServiceHandler } from "./storageHandlers";

export const FilesService: ServiceHandler = {
  async onCreate(listenerApi, normalized, meta) {
    if (normalized.value === null) {
      return;
    }
    try {
      listenerApi.dispatch(
        setSelectedObjectId({ service: "userfiles", id: normalized.id }),
      );
    } catch (e) {
      console.error("Ошибка при создании артефакта", e);
    }
  },
  async onSelect(listenerApi, id, value) {
    if (id === null || value === null) return;

    const { hash, filename } = (value as SaveFileValue).userfiles;
    const fileConfig = getFileConfig(filename);
    listenerApi.dispatch(setFileConfig(fileConfig));
    listenerApi.dispatch(setFilesValue(value as SaveFileValue));

    if (hash && fileConfig) {
      await dispatchCancellable(listenerApi.signal, () =>
        listenerApi.dispatch(getFileContentAction({ hash, fileConfig })),
      );
    }
  },
  async onLeave(listenerApi) {
    listenerApi.dispatch(clearFilesState());
  },
  // async onDelete(listenerApi, id, value) {
  //   if (id === null || value === null) return;
  //   try {
  //     const thread_id = (value as DialogValue)?.dialog_object?.thread_ref;
  //     if (thread_id) {
  //       listenerApi.dispatch(clearMessages());
  //       await deleteThread(thread_id);
  //     }
  //   } catch (e) {
  //     console.error("Нет объекта с таким ID");
  //   }
  // },
};
